import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgCircleQuestionSolid = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M12 21a9 9 0 0 0 9-9 9 9 0 0 0-9-9 9 9 0 0 0-9 9 9 9 0 0 0 9 9M8.97 8.811A1.97 1.97 0 0 1 10.826 7.5h2.05a2.218 2.218 0 0 1 1.103 4.145l-1.135.65a.846.846 0 0 1-.844.83.84.84 0 0 1-.844-.844v-.474c0-.303.162-.58.426-.732l1.557-.893a.532.532 0 0 0-.264-.991h-2.05a.28.28 0 0 0-.263.186l-.014.043a.844.844 0 0 1-1.589-.563l.014-.042zm4.155 6.564c0 .622-.503 1.125-1.125 1.125a1.124 1.124 0 0 1-1.125-1.125c0-.622.503-1.125 1.125-1.125s1.125.503 1.125 1.125"
    }));
export default SvgCircleQuestionSolid;
